"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function isTestEnv() {
  return !!(process && process.env && process.env.NODE_ENV === 'test');
}
var _default = function () {
  if (isTestEnv()) {
    return {};
  }
  var context = require.context('resources/assets/js', true, /^\.\/vendor\/flow\/export\.js$/);
  if (context.keys().length !== 1) {
    return {};
  }
  var plugins = context(context.keys()[0]);
  return plugins["default"] || plugins;
}();
exports["default"] = _default;